export default __webpack_public_path__ + "static/MariaTricarico-d413f0b5f56704bfdd7b31f4706382f5.png";